import { GeneralCoverageCard, GeneralVisitTile } from "../../../components";
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";

import { Divider } from "@mui/material";
import GenericCarousel from "../../../components/SelectableTimes/GenericCarousel";
import { IPetItemResponse } from "../../../services/pet-list/pet-list.interface";
import { IWellnessPlanBenefitUsage } from "../../../services/wellness-plan/wellness-plan.interface";
import WellnessMemberPlanCardOld from "../../../components/WellnessMemberPlanCard/WellnessMemberPlanCardOld";
import { fromUnixToFullDateNumNew } from "../../../utils/unix-timestamp";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { StyledBookingFlowButton } from "../BookingScheduleContainer/BookingScheduleContainer.style";
import { OverdueStatus, OVERDUE_STATUSES } from "../../../config/params";
import { getOverdueCtaText, handleOverdueCtaClick } from "../../../components/OutstandingPaymentCard/OutstandingPaymentCard";
import { useNavigate } from "react-router-dom";
import { useModal } from "../../../context/ModalContext";
import { ISquareInvoices } from "../../../services/delinquent-payment/delinquent-payment.interface";
import SocCoverageCardOld from "../../../components/SocCoverageCard/SocCoverageCardOld";


interface IWellnessMemberContainer {
  petList: IPetItemResponse[];
  handlePetChange: (petId: string, category?: string) => void;
  petData: IPetItemResponse;
  pendingInvoices: ISquareInvoices[];
  benifitUsageData: IWellnessPlanBenefitUsage[];
  planOverdueStatus:OverdueStatus | null;
  paymentUrl?: string;

}


const renderCoverageCards = (title: string, cards: JSX.Element[]) => (
  <>
    <div className="text-gray-1 font-semibold">{title}</div>
    <div className="flex gap-2">{cards}</div>
    <Divider sx={{ opacity: 0.8 }} className="w-full !m-0 border !border-gray-3" />
  </>
);

const WellnessMemberContainerOld = ({
  petList,
  handlePetChange,
  petData,
  paymentUrl,
  planOverdueStatus,
  pendingInvoices,
  benifitUsageData }: IWellnessMemberContainer) => {
  const [diagnosticPage, setDiagnosticPage] = useState(0);
  const [vaccinationPage, setVaccinationPage] = useState(0);
  const [preventativePage, setPreventativePage] = useState(0);
  const [wellnessBenifitData, setWellnessBenefitData] = useState<IWellnessPlanBenefitUsage[]>();
  const [vaccinationDetails, setVaccinationDetails] = useState<JSX.Element[]>([]);
  const [diagnosticDetails, setDiagnosticDetails] = useState<JSX.Element[]>([]);
  const [preventativeDetails, setPreventativeDetails] = useState<JSX.Element[]>([]);
  const [procedureDetails, setProcedureDetails] = useState<JSX.Element[]>([]);
  const [servicesDetails, setServicesDetails] = useState<JSX.Element[]>([]);
  const [consultationDetails, setConsultationDetails] = useState<JSX.Element[]>([]);
  const { user } = useUserStore();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate=useNavigate();
  const { openModal } = useModal();

  const isPlanViewDisabled=(overdueStatus: string)=>{
    if (planOverdueStatus) {
      if ((planOverdueStatus === OVERDUE_STATUSES.PAUSED) || (planOverdueStatus === OVERDUE_STATUSES.CANCELLED)) {
        return true;
      } else {
        return false;
      }
    }
  };


  useEffect(()=>{
    if (benifitUsageData) {
      setWellnessBenefitData(benifitUsageData);
    }
  }, [benifitUsageData]);


  useEffect(() => {
    if (wellnessBenifitData && wellnessBenifitData.length > 0) {
      const vaccinationResult: JSX.Element[] = wellnessBenifitData
        .filter((item) => item.mappedCategory === "Vaccination")
        .map((item, index) => {
          const lastuseddate = fromUnixToFullDateNumNew(item.modified_at,
            user?.location?.timeZone);

          return (<SocCoverageCardOld
            key={`vaccination-${index}`}
            title={item.displayName}
            counterCurrent={item.used}
            counterMax={item.allocated}
            lastGivenDate={ `${lastuseddate.day}/${lastuseddate.month}/${lastuseddate.year}`}
            type={item.mappedCategory}
          />);
        });

      const diagnosticResult: JSX.Element[] = wellnessBenifitData
        .filter((item) => item.mappedCategory === "Diagnostic")
        .map((item, index) => {
          const lastuseddate = fromUnixToFullDateNumNew(item.modified_at,
            user?.location?.timeZone);

          return <SocCoverageCardOld
            key={`diagnostic-${index}`}
            title={item.displayName}
            counterCurrent={item.used}
            counterMax={item.allocated}
            lastGivenDate={ `${lastuseddate.day}/${lastuseddate.month}/${lastuseddate.year}`}
            type={item.mappedCategory}
          />;
        });

      const preventativeResult: JSX.Element[] = wellnessBenifitData
        .filter((item) => item.mappedCategory === "Preventive Care")
        .map((item, index) => {
          const lastuseddate = fromUnixToFullDateNumNew(item.modified_at,
            user?.location?.timeZone);

          return <SocCoverageCardOld
            key={`preventative-${index}`}
            title={item.displayName}
            counterCurrent={item.used}
            counterMax={item.allocated}
            lastGivenDate={ `${lastuseddate.day}/${lastuseddate.month}/${lastuseddate.year}`}
            type={item.mappedCategory}
          />;
        });
      const procedureResult: JSX.Element[] = wellnessBenifitData
        .filter((item) => item.mappedCategory === "Procedure")
        .map((item, index) => {
          return <GeneralCoverageCard
            key={`procedure-${index}`}
            title={item.displayName}
            counterCurrent={item.used}
            counterMax={item.allocated}
            isSurgical={true}
          />;
        });
      const servicesResult: JSX.Element[] = wellnessBenifitData
        .filter((item) => item.mappedCategory === "Professional Services")
        .map((item, index) => {
          return <GeneralCoverageCard
            key={`services-${index}`}
            title={item.displayName}
            counterCurrent={item.used}
            counterMax={item.allocated}
          />;
        });
      const consultationResult: JSX.Element[] = wellnessBenifitData
        .filter((item) => item.mappedCategory === "Consultation")
        .map((item, index) => {
          return <GeneralVisitTile
            key={`consultation-${index}`}
            consultationTitle={item.displayName}
            counterValue={item.used}
            isUnlimited={item.allocated === -1 ? true : false}
          />;
        });

      setVaccinationDetails(vaccinationResult);
      setDiagnosticDetails(diagnosticResult);
      setPreventativeDetails(preventativeResult);
      setProcedureDetails(procedureResult);
      setServicesDetails(servicesResult);
      setConsultationDetails(consultationResult);
    }
  }, [wellnessBenifitData]);


  const vaccinationCards = vaccinationDetails;
  const diagnosticCards = diagnosticDetails;
  const preventativeCards = preventativeDetails;


  const itemsPerPage = 3;

  const vaccinationTotalPages = Math.ceil(vaccinationCards.length / itemsPerPage);
  const diagnosticTotalPages = Math.ceil(diagnosticDetails.length / itemsPerPage);
  const preventativeTotalPages = Math.ceil(preventativeCards.length / itemsPerPage);

  const visibleVaccinationCards = vaccinationCards.slice(
    vaccinationPage * itemsPerPage,
    vaccinationPage * itemsPerPage + itemsPerPage,
  );
  const visibleDiagnosticCards = diagnosticDetails.slice(
    diagnosticPage * itemsPerPage,
    diagnosticPage * itemsPerPage + itemsPerPage,
  );
  const visiblePreventativeCards = preventativeCards.slice(
    preventativePage * itemsPerPage,
    preventativePage * itemsPerPage + itemsPerPage,
  );


  const handleNextPage = (currentPage: number, setPage: any, totalPages: number) => {
    if (planOverdueStatus && isPlanViewDisabled(planOverdueStatus)) {
      return;
    } else {
      if (currentPage < totalPages - 1) {
        setPage(currentPage + 1);
      }
    }
  };

  const handlePrevPage = (currentPage: number, setPage: any) => {
    if (planOverdueStatus && isPlanViewDisabled(planOverdueStatus)) {
      return;
    } else {
      if (currentPage > 0) {
        setPage(currentPage - 1);
      }
    }
  };

  return (
    <div className="w-full bg-taupe-15 flex flex-col items-center p-4 gap-4">
      <div className={`w-full ${planOverdueStatus && !isLoading ? "bg-white rounded-xl" : ""}`}>
        <WellnessMemberPlanCardOld
          petList={petList}
          petData={petData}
          handlePetChange={handlePetChange}
          isSubscriptionBenefitAvailable
          planOverdueStatus={planOverdueStatus}
          setIsLoading={setIsLoading}
        />
        {planOverdueStatus && !isLoading &&
        <div className="p-4">
          <StyledBookingFlowButton
            disabled={false}
            fullWidth
            color="primary"
            size="small"
            onClick={() =>
              handleOverdueCtaClick(
                planOverdueStatus,
                petData.name,
                "wellness_plan",
                pendingInvoices,
                false,
                paymentUrl,
                navigate,
                openModal,
              )}
          >
            {getOverdueCtaText(planOverdueStatus)}
          </StyledBookingFlowButton>
        </div>}
      </div>

      <div className={`w-full bg-gray-2 px-4 py-6 flex flex-col gap-4 rounded-xl
        ${(planOverdueStatus && isPlanViewDisabled(planOverdueStatus)) ? "opacity-30" : ""}`}>
        <div className="font-semibold">Coverage Details & Progress</div>
        <Divider sx={{ opacity: 0.8 }} className="w-full !m-0 border !border-gray-3" />
        <div className="flex flex-col gap-1">
          {consultationDetails}
        </div>

        {renderCoverageCards("General", [
          <div key="general" className="grid grid-cols-2 md:flex md:flex-grow gap-2">
            {servicesDetails}
            {procedureDetails}
          </div>,
        ],
        )}

        {renderCoverageCards("Vaccinations", [
          vaccinationCards.length > itemsPerPage ? (
            <GenericCarousel
              currentIndex={vaccinationPage}
              handleNext={() => handleNextPage(vaccinationPage, setVaccinationPage, vaccinationTotalPages)}
              handleBack={() => handlePrevPage(vaccinationPage, setVaccinationPage)}
              optionsLength={vaccinationCards.length}
              itemsPerPage={itemsPerPage}
              position="below"
              key="vaccinations-carousel"
            >
              <div className="w-full grid grid-cols-3 gap-2">{visibleVaccinationCards}</div>
            </GenericCarousel>
          ) : (
            <div className="w-full grid grid-cols-2 md:flex gap-2">{vaccinationCards}</div>
          ),
        ])}

        {renderCoverageCards("Diagnostics", [
          diagnosticCards.length > itemsPerPage ? (
            <GenericCarousel
              currentIndex={diagnosticPage}
              handleNext={() => handleNextPage(diagnosticPage, setDiagnosticPage, diagnosticTotalPages)}
              handleBack={() => handlePrevPage(diagnosticPage, setDiagnosticPage)}
              optionsLength={diagnosticCards.length}
              itemsPerPage={itemsPerPage}
              position="below"
              key="diagnostics-carousel"
            >
              <div className="w-full grid grid-cols-3 gap-2">{visibleDiagnosticCards}</div>
            </GenericCarousel>
          ) : (
            <div className="w-full grid grid-cols-2 md:flex gap-2">{diagnosticCards}</div>
          ),
        ])}

        {renderCoverageCards("Preventative Care", [
          preventativeCards.length > itemsPerPage ? (
            <GenericCarousel
              currentIndex={preventativePage}
              handleNext={() => handleNextPage(preventativePage, setPreventativePage, preventativeTotalPages)}
              handleBack={() => handlePrevPage(preventativePage, setPreventativePage)}
              optionsLength={preventativeCards.length}
              itemsPerPage={itemsPerPage}
              position="below"
              key="preventative-carousel"
            >
              <div className="w-full grid grid-cols-3 gap-2">{visiblePreventativeCards}</div>
            </GenericCarousel>
          ) : (
            <div className="w-full grid grid-cols-2 md:flex gap-2">{preventativeCards}</div>
          ),
        ])}

        <div className="flex justify-center text-sm">
          <p className="text-center w-4/5">
          The GoodPet+ plan includes 10% off of additional services.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WellnessMemberContainerOld;
